export * from './collection-label.component';
